export interface MeshUiRuntimeConfig {
    apiBaseUrl: string;
    ccAppUrl: string;
}

interface RuntimeConfigWindow {
    meshUiRuntimeConfig?: MeshUiRuntimeConfig;
}

declare global {
    interface Window {
        meshUiRuntimeConfig?: MeshUiRuntimeConfig;
    }
}

export function getRuntimeConfig(runtimeWindow: RuntimeConfigWindow = window): MeshUiRuntimeConfig {
    const config = runtimeWindow.meshUiRuntimeConfig;
    if (!config) {
        throw new Error('assets/config/runtime-config.js did not define window.meshUiRuntimeConfig');
    }

    validateUrl('apiBaseUrl', config.apiBaseUrl);
    validateUrl('ccAppUrl', config.ccAppUrl);
    return config;
}

function validateUrl(name: string, value: string): void {
    let parsed: URL;
    try {
        parsed = new URL(value);
    } catch (_) {
        throw new Error(`window.meshUiRuntimeConfig.${name} is required and must be an absolute HTTP(S) URL`);
    }

    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
        throw new Error(`window.meshUiRuntimeConfig.${name} is required and must be an absolute HTTP(S) URL`);
    }
}
